import React from 'react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';

import type { IModalDialogContent, ModalDialogOptions, ModalWindow } from '@components/Modal.tsx';
import { ModalButtonType } from '@components/Modal.tsx';

export type CreateShareSpaceResult = {
  name: string;
  sizeGb: number;
};

@observer
export class CreateShareSpaceDialog extends React.Component implements IModalDialogContent<CreateShareSpaceResult> {
  @observable private _name = 'Shared Space';
  @observable private _sizeGb = '5';

  constructor(props: {}) {
    super(props);
    makeObservable(this);
  }

  getModalOptions(window: ModalWindow<CreateShareSpaceResult>): ModalDialogOptions<CreateShareSpaceResult> {
    const size = Number(this._sizeGb);
    const isValid = this._name.trim().length > 0 && Number.isFinite(size) && size >= 0;

    return {
      title: 'Create Share Space',
      width: '520px',
      closeByEscape: true,
      closeOnClickOutside: true,
      buttons: [
        {
          title: 'Create',
          type: ModalButtonType.Add,
          color: 'primary',
          isDisabled: !isValid,
          onClick: () => {
            window.close(ModalButtonType.Add, {
              name: this._name.trim(),
              sizeGb: size,
            });
          },
        },
        {
          title: 'Cancel',
          type: ModalButtonType.Cancel,
          onClick: () => window.close(ModalButtonType.Cancel),
        },
      ],
    };
  }

  render() {
    return (
      <div>
        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600 }}>Folder name</label>
          <input
            type="text"
            className="form-control"
            value={this._name}
            onChange={this._onNameChange}
            autoFocus
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600 }}>Space size (GB)</label>
          <input
            type="number"
            className="form-control"
            min={0}
            step={0.1}
            value={this._sizeGb}
            onChange={this._onSizeChange}
          />
          <small style={{ display: 'block', marginTop: '4px', color: 'var(--text-muted)' }}>Enter 0 for unlimited storage</small>
        </div>
      </div>
    );
  }

  @action.bound
  private _onNameChange(e: React.ChangeEvent<HTMLInputElement>) {
    this._name = e.target.value;
  }

  @action.bound
  private _onSizeChange(e: React.ChangeEvent<HTMLInputElement>) {
    this._sizeGb = e.target.value;
  }
}
